import { render, staticRenderFns } from "./TestListRoute.vue?vue&type=template&id=5cb4aed2&scoped=true&"
import script from "./TestListRoute.vue?vue&type=script&lang=js&"
export * from "./TestListRoute.vue?vue&type=script&lang=js&"
import style0 from "./TestListRoute.vue?vue&type=style&index=0&id=5cb4aed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4aed2",
  null
  
)

export default component.exports